import React, { useState } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import './Layout.css';

const Layout = () => {
  const { user, logout, isAdmin } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const isActive = (path) => location.pathname === path;

  const getPageTitle = () => {
    switch (location.pathname) {
      case '/shifts': return 'Мои смены';
      case '/tasks': return 'Задачи';
      case '/wiki': return 'База знаний';
      case '/dashboard': return 'Дашборд';
      case '/users': return 'Сотрудники';
      case '/shift-requests': return 'Запросы на обмен';
      default: return 'ShiftMaster';
    }
  };

  const getPageIcon = () => {
    switch (location.pathname) {
      case '/shifts': return 'fas fa-calendar-alt';
      case '/tasks': return 'fas fa-tasks';
      case '/wiki': return 'fas fa-book';
      case '/dashboard': return 'fas fa-chart-line';
      case '/users': return 'fas fa-users';
      case '/shift-requests': return 'fas fa-exchange-alt';
      default: return 'fas fa-home';
    }
  };

  return (
    <div className="app-container">
      {/* Сайдбар */}
      <aside className={`sidebar ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          
          <div className="sidebar-header-text">
            <h3>Mantera Digital</h3>
            <p>Управление сменами Novotel</p>
          </div>
          <button 
            className="toggle-sidebar"
            onClick={toggleSidebar}
            title={isSidebarCollapsed ? 'Развернуть меню' : 'Свернуть меню'}
          >
            <i className={`fas fa-chevron-${isSidebarCollapsed ? 'right' : 'left'}`}></i>
          </button>
        </div>
        
        <nav className="sidebar-menu">
          <Link 
            to="/shifts" 
            className={`menu-item ${isActive('/shifts') ? 'active' : ''}`}
            title="Мои смены"
          >
            <i className="menu-icon fas fa-calendar-alt"></i>
            <span>Мои смены</span>
          </Link>
          
          <Link 
            to="/tasks" 
            className={`menu-item ${isActive('/tasks') ? 'active' : ''}`}
            title="Задачи"
          >
            <i className="menu-icon fas fa-tasks"></i>
            <span>Задачи</span>
          </Link>
          
          <Link 
            to="/wiki" 
            className={`menu-item ${isActive('/wiki') ? 'active' : ''}`}
            title="База знаний"
          >
            <i className="menu-icon fas fa-book"></i>
            <span>База знаний</span>
          </Link>
          
          {isAdmin() && (
            <>
              <Link 
                to="/dashboard" 
                className={`menu-item ${isActive('/dashboard') ? 'active' : ''}`}
                title="Аналитика"
              >
                <i className="menu-icon fas fa-chart-line"></i>
                <span>Аналитика</span>
              </Link>
              
              <Link 
                to="/users" 
                className={`menu-item ${isActive('/users') ? 'active' : ''}`}
                title="Сотрудники"
              >
                <i className="menu-icon fas fa-users"></i>
                <span>Сотрудники</span>
              </Link>
              
              <Link 
                to="/shift-requests"
                className={`menu-item ${isActive('/shift-requests') ? 'active' : ''}`}
                title="Запросы"
              >
                <i className="menu-icon fas fa-exchange-alt"></i>
                <span>Запросы</span>
              </Link>
            </>
          )}
        </nav>

        {/* Кнопка выхода */}
        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout} title="Выйти из системы">
            <i className="fas fa-sign-out-alt"></i>
            <span>Выйти</span>
          </button>
        </div>
      </aside>

      {/* Основной контент */}
      <main className={`main-content ${isSidebarCollapsed ? 'expanded' : ''}`}>
        <div className="top-bar">
          <div className="page-title">
            <i className={getPageIcon()}></i>
            <h1>{getPageTitle()}</h1>
          </div>
          
          <div className="user-menu">
            <div className="user-avatar">
              {user?.username?.substring(0, 2).toUpperCase()}
            </div>
            <div className="user-info">
              <div className="user-name">{user?.username}</div>
              <div className={`role-badge ${isAdmin() ? 'role-admin' : 'role-user'}`}>
                {isAdmin() ? 'Администратор' : 'Сотрудник'}
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;